import { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { Box, IconButton, Menu, Stack, Typography } from '@mui/material';
import { COLOR_ACCENT, COLOR_BG, COLOR_PRIMARY, COLOR_WH, Icons, useModal } from 'shared';
import { headerNavLinks, socials } from 'widgets/layout/constants';

import { MobileNavTitle, NavLinkWithAccordion } from '..';

export const MobileMenu = () => {
  const [isMenuVisible, onOpenMenu, onCloseMenu] = useModal(false);
  const anchorRef = useRef();

  return (
    <Box
      ref={anchorRef}
      sx={{
        display: {
          md: 'none',
        },
      }}
    >
      <IconButton
        onClick={onOpenMenu}
        color="secondary"
        sx={{
          borderColor: COLOR_ACCENT,
        }}
      >
        <Icons.Menu />
      </IconButton>

      <Menu
        onClose={onCloseMenu}
        open={isMenuVisible}
        marginThreshold={0}
        anchorEl={anchorRef.current}
        PaperProps={{
          sx: {
            m: 0,
            borderRadius: 0,
            top: '0 !important',
            left: '0 !important',
            p: 3,
            pt: 4,
            maxWidth: '100vw',
            width: '100%',
            maxHeight: '100vh',
            height: '100%',
            background: COLOR_BG,
          },
        }}
        MenuListProps={{
          sx: {
            p: 0,
            gap: 0,
            height: '100%',
          },
        }}
        sx={{ display: { md: 'none' } }}
      >
        <Stack direction="row" justifyContent="flex-end">
          <IconButton
            onClick={onCloseMenu}
            color="secondary"
            className="rounded"
            sx={{
              width: 48,
              height: 48,
            }}
          >
            <Icons.Close
              sx={{
                color: COLOR_WH,
              }}
            />
          </IconButton>
        </Stack>
        <Stack flexGrow={1} height="100%">
          <Stack component="nav" spacing={4} mt={5} flexGrow={1}>
            {headerNavLinks.map(({ title, path, subpaths }) => {
              return subpaths ? (
                <NavLinkWithAccordion title={title} navItems={subpaths} onMenuItemClick={onCloseMenu} key={title} />
              ) : (
                <NavLink onClick={onCloseMenu} key={title} to={path}>
                  <MobileNavTitle>{title}</MobileNavTitle>
                </NavLink>
              );
            })}
          </Stack>
          <Typography variant="body2" className="center" mt="auto" pt={10}>
            Copyright © 2026 CratD2C
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={4} mt={4}>
            {socials.map(({ Icon, url }) => {
              return (
                <a aria-label="Social" key={url} rel="noreferrer" href={url} target="_blank">
                  <Icon
                    sx={{
                      color: COLOR_PRIMARY,
                    }}
                  />
                </a>
              );
            })}
          </Stack>
        </Stack>
      </Menu>
    </Box>
  );
};
